"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var AvatarPopup_component_exports = {};
__export(AvatarPopup_component_exports, {
  AvatarPopup: () => AvatarPopup
});
module.exports = __toCommonJS(AvatarPopup_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = require("react");
var import_react2 = require("@floating-ui/react");
var import_Helpers = require("../../utils/Helpers");
var import_AvatarCard = require("./AvatarCard/AvatarCard.component");
var import_Button = require("@greatmindsorg/gmui-lib/dist/components/Button/Button.component");
var import_useLeaveAvatarPopup = __toESM(require("./useLeaveAvatarPopup.hook"));
const AvatarPopup = ({
  firstName = "",
  lastName = "",
  email = "",
  onLogout,
  currentRole,
  availableRoles = [],
  onSwitchRole
}) => {
  const [isOpen, setIsOpen] = (0, import_react.useState)(false);
  const avatarCardRef = (0, import_react.useRef)(null);
  (0, import_useLeaveAvatarPopup.default)(isOpen, avatarCardRef, setIsOpen);
  const toggleIsOpen = () => {
    setIsOpen(!isOpen);
  };
  const handleSwitchRole = (role2) => {
    onSwitchRole(role2);
  };
  const { refs, floatingStyles, context } = (0, import_react2.useFloating)({
    placement: "bottom-end",
    open: isOpen,
    onOpenChange: (open) => {
      setIsOpen(open);
    },
    whileElementsMounted: import_react2.autoUpdate,
    middleware: [(0, import_react2.offset)(14), (0, import_react2.flip)({ fallbackPlacements: ["bottom-start"] })]
  });
  const dismiss = (0, import_react2.useDismiss)(context);
  const role = (0, import_react2.useRole)(context);
  const { getReferenceProps, getFloatingProps } = (0, import_react2.useInteractions)([dismiss, role]);
  const buttonRef = (0, import_react.useRef)(null);
  (0, import_react.useEffect)(() => {
    if (buttonRef.current) refs.setReference(buttonRef.current);
  }, []);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", { id: "avatar-popup-id", children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      import_Button.Button,
      __spreadProps(__spreadValues({
        className: "avatar-popup-button gmui-font-style-body gmui-themed-font-weight-body-medium",
        onPress: toggleIsOpen,
        ref: buttonRef,
        "aria-label": `User menu, logged in as: ${firstName} ${lastName}`
      }, getReferenceProps()), {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Button.Button.Label, { children: (0, import_Helpers.getInitials)(firstName, lastName) })
      })
    ),
    isOpen && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react2.FloatingPortal, { id: "avatar-popup-id", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react2.FloatingFocusManager, { context, modal: false, closeOnFocusOut: false, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      "div",
      __spreadProps(__spreadValues({
        ref: refs.setFloating,
        style: floatingStyles,
        "aria-label": "User menu"
      }, getFloatingProps()), {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          import_AvatarCard.AvatarCard,
          {
            firstName,
            lastName,
            email,
            currentRole,
            onLogout,
            availableRoles,
            avatarCardRef,
            onSwitchRole: handleSwitchRole
          }
        )
      })
    ) }) })
  ] });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AvatarPopup
});
//# sourceMappingURL=AvatarPopup.component.js.map